<template>
  <v-menu offset-y>
    <v-btn flat slot="activator">
      {{$i18n.locale}}
      <v-icon>language</v-icon>
    </v-btn>
    <v-list two-line>
      <template v-for="(language, id) in languages">
        <v-list-tile :key="id" avatar @click="setCurrentLanguage(id)">
          <template c-slot:default="{ active, toggle }">
            <v-list-tile-action>
              <v-checkbox v-model="language.current" color="deep-purple accent-1"></v-checkbox>
            </v-list-tile-action>

            <v-list-tile-avatar>
              <v-icon>language</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-html="language.name"></v-list-tile-title>
              <v-list-tile-sub-title v-html="id"></v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </v-list-tile>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'LanguageControl',
  components: {},
  mounted() {
    this.languages[this.$i18n.locale].current = true;
  },
  data: () => {
    return {
      saving: 0,
      languages: {
        it: {
          name: 'Italiano',
          current: false
        },
        en: {
          name: 'English',
          current: false
        },
        pl: {
          name: 'Polski',
          current: false
        }
      }
    };
  },
  methods: {
    setCurrentLanguage(id) {
      Object.keys(this.languages).forEach(iid => {
        this.languages[iid].current = false;
      });
      this.languages[id].current = true;
      this.$i18n.locale = id;
      let settings = JSON.parse(window.localStorage.getItem('settings')) || {};
      settings.language = id;
      window.localStorage.setItem('settings', JSON.stringify(settings));
    }
  },
  computed: {}
};
</script>

<style>
</style>
